import {DescriptionText, H1Text} from "../../../../../design";
import React from "react";
import SmallScreenHeader from "../../../../../components/smallscreen/header";

type Props = {
  account: Object,
  subscription: Object
}

const Header = (props:Props) => {
  const {account, subscription} = props;
  return (
    <SmallScreenHeader>
      <H1Text>
        {account && account.name}
      </H1Text>
      <DescriptionText >
        {subscription && subscription.description}
      </DescriptionText>
    </SmallScreenHeader>
  )
};

export default Header;
